import React from 'react';
import {translate} from 'react-i18next';
import PageHeader from "../../components/elements/PageHeader";
import ProjectApi from "../../apis/ProjectApi";
import AddProject from "./AddProject";
import EditProject from "./EditProject";
import {receiveAvailableProjects} from "../../actions/projectAction";
import {connect} from "react-redux";

class ProjectManagement extends React.Component {

    state = {
        loading: true,
        projects: []
    };

    componentDidMount() {
        this.getProjects();
    }

    getProjects = () => {
        this.setState({loading: true});
        ProjectApi.getProjects()
            .then((response) => {
                if(response.status === 200 && response.data.success === true) {
                    this.setState({
                        projects: response.data.data,
                        loading: false
                    });
                    this.props.receiveAvailableProjects(response.data.data);
                }
            });
    };

    render() {
        const {t} = this.props;
        return (
            <div className="ProjectManagement">
                <PageHeader title={t('projectManagement.title')} loading={this.state.loading}/>
                <div className="row m-t">
                    <div className="col-xs-12 text-right">
                        <AddProject onSuccess={this.getProjects}/>
                    </div>
                </div>
                <div className="row m-t">
                    <div className="col-xs-12">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>
                                    {t('projectManagement.table.displayName')}
                                </th>
                                <th>
                                    {t('projectManagement.table.active')}
                                </th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.projects.map((project, pI) => (
                                <tr key={pI}>
                                    <td>
                                        {project.displayName}
                                    </td>
                                    <td>
                                        {project.active ? (
                                            <i className="fa fa-check text-primary"/>
                                        ) : (
                                            <i className="fa fa-close text-danger"/>
                                        )}
                                    </td>
                                    <td className="text-right">
                                        <EditProject project={project} onSuccess={this.getProjects}/>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(null, {
    receiveAvailableProjects
})(translate()(ProjectManagement));
